// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 25) return "static/js/633b0d43db47e013b4b1.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"6f92d315f4411ad9a20d","122":"8e26dde75ddc59369f34","123":"1caa561e0f37ab802b7f"}[chunkId] + ".chunk.js";
};